/**
 * Enum class for appointment display statuses
 *
 * @class AppointmentDisplayStatusEnum
 */
module.exports = {
  SCHEDULED: {
    name: 'SCHEDULED',
    messageKey: 'appointment.status.scheduled'
  },
  PRE_REG_OPEN: {
    name: 'PRE_REG_OPEN',
    messageKey: 'appointment.status.preRegOpen'
  },
  PRE_REG_COMPLETED: {
    name: 'PRE_REG_COMPLETED',
    messageKey: 'appointment.status.preRegComplete'
  },
  PRE_REG_CLOSED: {
    name: 'PRE_REG_CLOSED',
    messageKey: 'appointment.status.preRegClosed'
  },
  CHECKED_IN: {
    name: 'CHECKED_IN',
    messageKey: 'appointment.status.checkedIn'
  },
  CANCELED: {
    name: 'CANCELED',
    messageKey: 'appointment.status.canceled'
  },
  RESCHEDULED: {
    name: 'RESCHEDULED',
    messageKey: 'appointment.status.rescheduled'
  },
  PAST: {
    name: 'PAST',
    messageKey: 'appointment.status.past'
  }
};
